export enum billsActionTypes {
  UPDATE_RPU = 'update_rpu',
  UPDATE_MASS_UPLOAD_FILE = 'update_mass_upload_file',
  UPDATE_MASS_UPLOAD_RPU_LIST = 'update_mass_upload_rpu_list',
  ADD_RPU_TO_REQUESTED_BILLS = 'add_rpu_to_requested_bills',
}
